var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Gifto.Mall",
    "options": {
        "objc_class_prefix": "GiftoMallCurrencyInfo",
        "java_package": "com.asiainno.uplive.proto.gift"
    },
    "messages": [
        {
            "name": "GiftoMallCurrencyInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "giftoCurrencyCode",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "giftoCurrencyShowName",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "iconUrl",
                    "id": 3
                }
            ]
        },
        {
            "name": "GiftList",
            "fields": [],
            "options": {
                "objc_class_prefix": "GiftoMallGiftList",
                "java_package": "com.asiainno.uplive.proto.gift"
            },
            "messages": [
                {
                    "name": "Request",
                    "fields": [
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "scene",
                            "id": 1
                        }
                    ]
                },
                {
                    "name": "Response",
                    "fields": [
                        {
                            "rule": "repeated",
                            "type": "GiftInfo",
                            "name": "gifts",
                            "id": 1
                        },
                        {
                            "rule": "repeated",
                            "type": "BatchSendConfig",
                            "name": "batchSendConfigs",
                            "id": 2
                        }
                    ]
                },
                {
                    "name": "GiftInfo",
                    "fields": [
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "giftId",
                            "id": 1
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "name",
                            "id": 2
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "intro",
                            "id": 3
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "type",
                            "id": 4
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "url",
                            "id": 5
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "price",
                            "id": 6
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "experience",
                            "id": 7
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "version",
                            "id": 8
                        },
                        {
                            "rule": "optional",
                            "type": "bool",
                            "name": "onLined",
                            "id": 9
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "countryCode",
                            "id": 10
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "language",
                            "id": 11
                        },
                        {
                            "rule": "optional",
                            "type": "bool",
                            "name": "needLoad",
                            "id": 12
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "showType",
                            "id": 13
                        },
                        {
                            "rule": "repeated",
                            "type": "GiftResourceInfo",
                            "name": "resources",
                            "id": 14
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "vipGrade",
                            "id": 15
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "playTimes",
                            "id": 16
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "produceType",
                            "id": 17
                        },
                        {
                            "rule": "optional",
                            "type": "bool",
                            "name": "canSendToAllUsers",
                            "id": 18
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "timeLimit",
                            "id": 19
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "hostBill",
                            "id": 20
                        },
                        {
                            "rule": "optional",
                            "type": "GiftoMallCurrencyInfo",
                            "name": "currencyInfo",
                            "id": 21
                        }
                    ]
                },
                {
                    "name": "GiftResourceInfo",
                    "fields": [
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "type",
                            "id": 1
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "url",
                            "id": 2
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "md5",
                            "id": 3
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "json",
                            "id": 4
                        }
                    ]
                },
                {
                    "name": "BatchSendConfig",
                    "fields": [
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "number",
                            "id": 1
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "description",
                            "id": 2
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "effectLevel",
                            "id": 3
                        }
                    ]
                }
            ]
        }
    ]
}).build();
export default _root;


// WEBPACK FOOTER //
// ./js/living/gift/gto/giftomall-giftlist.pb.js